import { render } from "./loading.vue?vue&type=template&id=d960adee&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=d960adee&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d960adee"],['__file',"src/components/loading/loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d960adee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d960adee', __exports__)) {
    console.log('reload')
    api.reload('d960adee', __exports__)
  }
  
  module.hot.accept("./loading.vue?vue&type=template&id=d960adee&scoped=true", () => {
    console.log('re-render')
    api.rerender('d960adee', render)
  })

}


export default __exports__